export const BackButton = ({ color = "white" }: { color?: string }) => {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.92163 14.4355L0.92163 7.43555L5.92163 0.435547"
                stroke={color}
                strokeWidth="1.5"
            />
        </svg>
    );
};
 